// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".textinput-ctn .checkbox {\n  float: right;\n  margin-top: 2px;\n  margin-right: 2px;\n}\n.hide {\n  display: none;\n}\n", ""]);
// Exports
module.exports = exports;
